'use strict';
var twentyninetimes = twentyninetimes || {};
var joblist = document.getElementById('js-job-list');

twentyninetimes.joblist = twentyninetimes.joblist || function () {

	function init() {
        if(joblist) {
          var showCheckboxesBtn = document.getElementById('showCheckboxesBtn');
          var checkboxContainer = document.getElementById('checkboxContainer');

          if(showCheckboxesBtn && checkboxContainer) {
            // Add event listener for showCheckboxesBtn click
            showCheckboxesBtn.addEventListener('click', function() {
                // Toggle the display of the checkbox container
                if(!checkboxContainer.classList.contains('filter-dropdown-list--open')) {
                  showCheckboxesBtn.classList.add('filter-dropdown__trigger--open');
                  checkboxContainer.classList.add('filter-dropdown-list--open');
                } else {
                  showCheckboxesBtn.classList.remove('filter-dropdown__trigger--open');
                  checkboxContainer.classList.remove('filter-dropdown-list--open');
                }
            });
          
            generateCheckboxes(); // Call the function when DOM content is loaded
          }
        }
    }
    
        
    function generateCheckboxes() {
        // Get the list of items
        var itemList = document.getElementById('js-job-list');
        var allItems = itemList.querySelectorAll('.item-job');
        var items = itemList.querySelectorAll('.item-job');
      
        // Get the container element for checkboxes
        var checkboxContainer = document.getElementById('checkboxContainer');
      
        // Clear any existing checkboxes
        checkboxContainer.innerHTML = '';
      
        // Create an array to store unique types
        var types = [];
  
        // Loop through the items and generate checkboxes and populate types array
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          var officeType = item.querySelector('.item-job__office').innerText;

        //   Add type to types array if not already present
          if (types.indexOf(officeType) === -1) {
            types.push(officeType);
          }

        }

        for (var i = 0; i < types.length; i++) {
            var officeType = types[i];
            // Create a new div to wrap checkbox and label
            var checkboxWrapper = document.createElement('div');
            checkboxWrapper.classList.add('filter-dropdown-list__item');
        
            // Create a new checkbox
            var checkbox = document.createElement('input');
            checkbox.id = 'office-type-' + officeType.replace(' ', '-').toLowerCase();
            checkbox.type = 'checkbox';
            checkbox.value = officeType;
            checkbox.name = 'selectedTypes'; // Set a common name for all checkboxes
        
            // Create a label for the checkbox
            var label = document.createElement('label');
            label.setAttribute('for', 'office-type-' + officeType.replace(' ', '-').toLowerCase());
            label.innerHTML = officeType;
        
            // Append checkbox and label to the checkbox wrapper
            checkboxWrapper.appendChild(checkbox);
            checkboxWrapper.appendChild(label);
        
            // Append the checkbox wrapper to the checkbox container
            checkboxContainer.appendChild(checkboxWrapper);
        }

      
        // Add event listener for checkbox change
        checkboxContainer.addEventListener('change', function(event) {
          var selectedTypes = []; // Array to store selected types
          var checkboxes = checkboxContainer.getElementsByTagName('input');
      
          // Loop through the checkboxes and get the selected types
          for (var i = 0; i < checkboxes.length; i++) {
            var checkbox = checkboxes[i];
            if (checkbox.checked) {
              selectedTypes.push(checkbox.value);
            }
          }


          if(selectedTypes.length != 0) {
            // Loop through the items and show/hide based on selected types
            for (var i = 0; i < items.length; i++) {
              var item = items[i];
              var type = item.querySelector('.item-job__office').innerText;
              if (selectedTypes.indexOf(type) !== -1) {
                item.style.display = 'flex';
              } else {
                item.style.display = 'none';
              }
            }
          } else {
            for(var i = 0; i < items.length; i++) {
                var item = items[i];
                item.style.display = 'flex';
            }
          }
          
      
        });
      }

	return {
		init : init
	};

}();